<template lang="pug">
  transition(name='modal')
    .modal-mask(@click.self="closeModal()")
      .modal-wrapper(@click.self="closeModal()")
        .modal-container(:style="containerStyle")
          .modal-header
            p.title {{ tituloModal }}
            el-button.btn#btn(
              type="text",
              @click="triggerCloseModal()",
              @mouseover.native="hover",
              @mouseout.native="leave",
              :style="getColor",
              size="mini"
            )
              i.material-icons.icon close

          .modal-body(:style="{ padding: padding + 'px' }")
            div(v-if="tipo === 'trocaResponsavel'")
              el-row.processo
                p Processo:
                  b &nbsp Trocar responsável

              el-row.row
                p Selecione abaixo o nome do responsável a ser vinculado no processo:
              el-select.full-width(
                v-model='usuarioVinculado',
                placeholder='Selecione o responsável',
                no-match-text="Usuário não encontrado",
                no-data-text="Nenhum usuário disponível",
                filterable,
                clearable,
              )
                el-option(
                  v-for='usuario in usuariosDisponiveis',
                  :key='usuario.id',
                  :label='usuario.pessoa.nomeRazaoSocial',
                  :value='usuario.id'
                )
            div(v-if="tipo === 'visualizarProcesso'")
              h1 Visualizar Processo
          .modal-footer
            slot(name="footer")
              el-button(v-if="tipo === 'trocaResponsavel'" @click="trocarResponsavel") Confirmar

</template>

<script>

import axios from '@/utils/api'
import AppNotificacao from './mixins/AppNotificacao'

export default {

  props: {
    width: {
      type: Number,
      default: 800
    },
    closeOutside: {
      type: Boolean,
      default: true
    },
    padding: {
      type: Number,
      default: 10
    },
    height: {
      type: Number
    },
    tipo: String,
    required: true
  },

  mixins: [
    AppNotificacao
  ],

  data () {
    return {
      colorCopy: '#666666',
      hoverColor: '#079D67',
      usuarioVinculado: null,
      usuariosDisponiveis: []
    }
  },

  computed: {
    getColor () {
      if (this.colorCopy) {
        return `color: ${this.colorCopy}`
      }
      return ''
    },

    tituloModal () {
      switch (this.tipo) {
        case 'trocaResponsavel' :
          return 'Trocar Responsável'
        case 'visualizarProcesso' :
          return 'Visualizar processo'
        default:
          return '-'
      }
    },

    containerStyle () {
      const style = {
        width: `${this.width}px`
      }

      if (this.height) {
        style.height = `${this.height}px`
      }

      return style
    }
  },

  methods: {
    closeModal () {
      if (this.closeOutside) {
        this.triggerCloseModal()
      }
    },

    async trocarResponsavel () {
      const processo = {
        id: 1,
        usuario: {
          id: this.usuarioVinculado
        }
      }
      this.usuariosDisponiveis = await axios({
        method: 'post',
        url: 'publico/processo/trocaAnalista',
        data: processo
      }).then(() => {
        this.showNotificacao(this.$messages.TIPO_SUCCESS, this.$messages.TITULO_SUCCESS,
          'Responsavel alterado com sucesso')
      })
    },

    triggerCloseModal () {
      this.$emit('closeModal')
    },

    hover () {
      this.colorCopy = this.hoverColor
    },

    leave () {
      this.colorCopy = this.cor
    }
  }

}

</script>

<style scoped lang="scss">

  .modal-mask {
    position: fixed;
    z-index: 8;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, .5);
    display: table;
    transition: opacity .3s ease;
  }

  .full-width {
    width: 95%;
  }

  .modal-wrapper {
    margin-top: 8vh;
  }

  .modal-container {
    min-height: 200px;
    max-height: 84vh;
    margin: 0px auto;
    background-color: #fff;
    box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
    transition: all .3s ease;
    font-family: Helvetica, Arial, sans-serif;
    -moz-border-radius: 5px;
    -webkit-border-radius: 5px;
    border-radius: 10px;
    display: flex;
    flex-direction: column;
  }

  .modal-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    background-color:#009f60;
    border-radius: 10px 10px 0 0;
    height: 55px;
  }

  .modal-body {
    padding: 10px;
    margin: 10px 30px;
    overflow-y: auto;
    max-height: 76vh;
    flex-grow: 1;
  }

  .modal-footer {
    display: flex;
    justify-content: flex-end;
    background-color: white;
    padding: 10px;
    border-radius: 0px 0px 10px 10px;
  }

  .modal-enter {
    opacity: 0;
  }

  .modal-leave-active {
    opacity: 0;
  }

  .title {
    margin: 0;
    font-size: 18px;
    color: white !important;
    font-weight: bold;
    padding: 0 10px;
    margin-bottom: 0px !important;
  }

  .btn {
    padding-right: 20px;
    color: white;

    .icon {
      font-size: 18px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/AppModalNova.vue